<template>
  <el-card>
    <template #header>
      <content-header />
    </template>


    <el-button-group class="mb-4">
      <search-form :fields="search" />
      <button-link v-if="hasPermsCreate" :to="`printer-devices/create`">添加</button-link>
    </el-button-group>

    <el-table :data="printerDevices" resource="printer-devices">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="terminal_number" label="终端号" />
      <el-table-column prop="terminal_msign" label="终端密钥" />

      <el-table-column prop="status_text" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status" type="success" disable-transitions>可用</el-tag>
          <el-tag v-else type="warning" disable-transitions>禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="添加时间" width="170" />
      <el-table-column prop="updated_at" label="修改时间" width="170" />
      <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit v-if="hasPermsEdit" />
            <row-destroy v-if="hasPermsDelete" />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getPrinterDevices } from '@/api/printer-devices'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'
import { can } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    return {
      search: [
        {
          field: 'name',
          label: '名称',
        },
        {
          field: 'status',
          label: '状态',
          type: 'el-select',
          options: [
            { id: 0, name: '禁用' },
            { id: 1, name: '可用' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
      ],
      printerDevices: [],
      page: null,
      hasPermsDelete: false,
      hasPermsCreate: false,
      hasPermsEdit: false,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const { data: { data, meta } } = await getPrinterDevices(newVal.query)
        this.printerDevices = data
        this.page = meta
      },
      immediate: true,
    },
  },
  created() {
    this.hasPermsDelete = can('printer-devices.delete')
    this.hasPermsEdit = can('printer-devices.edit')
    this.hasPermsCreate = can('printer-devices.create')
  },
}
</script>
